<div id="sunburst" #sunburst>
    <p *ngIf="!sunburstData.length" class="mt">No Data</p>
</div>